// extracted by mini-css-extract-plugin
module.exports = {"main":"main_main__1DpW4","accounts":"main_accounts__nnGep","accountsBlock":"main_accountsBlock__3anEg","display":"main_display__EN9A9"};